module.exports = "/assets//img/679e57dd11ec244942212b7d5f15324b.jpg";